import React from 'react';

export default function Auth({ isAdmin, isAuthenticated }) {
  return (
    <>
      <div style={{ display: isAuthenticated && !isAdmin ? '' : 'none' }}>
        <p>
          You are authenticated, but you are not an admin. There won't be much
          for you to do here.
        </p>
      </div>
      <div style={{ display: !isAuthenticated ? '' : 'none' }}>
        <p>You are not authenticated. Please log in to access more features.</p>
      </div>
    </>
  );
}
